import { render, staticRenderFns } from "./important.html?vue&type=template&id=f22abeee&"
import script from "./Important.vue?vue&type=script&lang=js&"
export * from "./Important.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports